import React from 'react'

import { Navbar, Footer } from '../../../components';
import PremiumArticle from './PremiumArticle';

export default function Premarticle3() {
  return (
    <div className='emas__article1'>
        <Navbar />
        <PremiumArticle article="article3" headerImage="sunset.jpg" reference="https://www.pexels.com/photo/sky-sunset-sun-twilight-46169/" photographer="Pixabay" />
        <Footer />
        <Footer />
    </div>
  )
}
